import { createContext, useContext, useEffect, useState } from 'react';

const AuthContext = createContext();

export const AuthContextProvider = ({ children }) => {
  const [user, setUser] = useState(() => {
    const savedUser = localStorage.getItem('usuario-cardexmedico');
    return savedUser ? JSON.parse(savedUser) : null;
  });

  const [authenticationToken, setAuthenticationToken] = useState(() => localStorage.getItem('authentication-token-cardexmedico') || null);
  const [refreshToken, setRefreshToken] = useState(() => localStorage.getItem('refresh-token-cardexmedico') || null);

  const login = (user_, authenticationToken_, refreshToken_) => {
    localStorage.setItem('usuario-cardexmedico', JSON.stringify(user_));
    localStorage.setItem('authentication-token-cardexmedico', authenticationToken_);
    localStorage.setItem('refresh-token-cardexmedico', refreshToken_);
    setUser(user_)
    setAuthenticationToken(authenticationToken_)
    setRefreshToken(refreshToken_)
  };

  const logout = () => {
    localStorage.removeItem('usuario-cardexmedico');
    localStorage.removeItem('authentication-token-cardexmedico');
    localStorage.removeItem('refresh-token-cardexmedico');
    setUser(null);
    setAuthenticationToken(null);
    setRefreshToken(null)
  };

  useEffect(()=>{
    localStorage.setItem('usuario-cardexmedico', JSON.stringify(user));
  },[user])

  return (
    <AuthContext.Provider value={{ user, setUser, authenticationToken, refreshToken, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook for easy access
export const useAuth = () => useContext(AuthContext);
